import React from 'react';
import $ from 'jquery';

export const useContactForm = () => {

    const [status, setStatus] = React.useState({
        submitted: false,
        submitting: false,
        info: { error: false },
    });

    const [values, setValues] = React.useState({});

    const handleResponse = (success: boolean, message: string) => {
        if (success) {
            setStatus({
                submitted: true,
                submitting: false,
                info: { error: false, message },
            });

            setValues({});
        } else {
            setStatus({
                submitted: false,
                submitting: false,
                info: { error: true, message },
            });
        }
    };

    const onChange = (e) => {
        e.persist();

        setValues(prev => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));

        setStatus({
            submitted: false,
            submitting: false,
            info: { error: false },
        });
    };

    const send = async (e) => {
        e.preventDefault();

        setStatus(prev => ({ ...prev, submitting: true }));

        $.ajax({
            method: 'POST',
            contentType: 'application/json',
            url: '/api/contact/',
            data: JSON.stringify(values),
        }).done((result) => {
            if (result.success) {
                handleResponse(true, 'Thank you for getting in touch! We will get back in touch with you soon.');
            }
        }).fail(() => {
            handleResponse(
                false,
                'Could not send email. Please try again later.'
            );
        });
    };

    return {
        status,
        setStatus,
        values,
        onChange,
        send,
    };
};
